<template>
<v-container>
    <v-row class="pb-10">
        <v-col cols="12">
            <div class="display-1">
                {{$t('my_applications')}}
            </div>
        </v-col>
    </v-row>
    <v-row tag="v-container" no-gutters v-bind:key="application.id" v-for="(application) in applications">
        <v-col cols="12">
            <Application :application="application">
            </Application>
        </v-col>
    </v-row>
    <v-row tag="v-container" no-gutters v-show="!applications.length">
        <v-col align="center" justify="center" cols="12">
            <p class="title">{{$t('no_applications')}}</p>
            <v-btn
                outlined
                large
                to="/panel/offers">
                {{$t('post_application')}}
            </v-btn>
        </v-col>
    </v-row>
    <ChangeApplicationData></ChangeApplicationData>
</v-container>
</template>

<script>

import Application from "@/app/client/applications/shared/components/application.vue";
import ChangeApplicationData from '@/app/client/applications/shared/modals/changeApplicationData';

export default {
  name: 'MyApplications',
  components: {
    ChangeApplicationData,
    Application
  },
  data() {
    return {
      sortField: 'created_at',
      sortOrder: 'desc',
      loading: false,
    };
  },
  computed: {
    applications() {
      return this.$store.getters.GET_APPLICATIONS_FOR_USER;
    },
  },
  created() {
    this.$store.dispatch('GET_APPLICATIONS_BY_PROFILE');
  },
  methods: {
    type(status) {
      return status;
    },
  },
};
</script>

<style>

</style>
